import "./Articlebanner.css";

function Articlebanner({ image }) {
  const backend = process.env.REACT_APP_BACKEND_LINK;
  const imageUrl = image?.startsWith("http")
    ? image
    : `${backend.replace(/\/$/, "")}${image}`;

  return (
    <section id="article-banner">
      <div
        className="article-banner-cover"
        style={{ backgroundImage: image ? `url(${imageUrl})` : undefined }}
      />
    </section>
  );
}

export default Articlebanner;
